import React, { FC } from 'react';
import { IBusiness, sum } from '../utils/utils';
import BusinessCommissionItem from '../DetailItem/BusinessCommissionItem';
import { APAS, Role } from '../../../common/constants';
import CustomAccordion from '../../../common/components/CustomAccordion/CustomAccordion';
import { Grid } from '@material-ui/core';

interface Params {
  businessState: IBusiness;
  setBusinessState: React.Dispatch<React.SetStateAction<IBusiness>>;
  canEditBusiness: boolean;
}

const BusinessCommissions: FC<Params> = (props) => {
  const { businessState, setBusinessState, canEditBusiness } = props;

  const commissionsMandaAmounts =
    businessState.mandaCommissions?.map((commission) => commission.amount) ||
    [];
  const commissionsApaAmounts =
    businessState.apaCommissions?.map((commission) => commission.amount) || [];

  const totalCommissions = [
    ...commissionsMandaAmounts,
    ...commissionsApaAmounts,
  ];

  const amount = sum(totalCommissions);

  const title = 'Commissionnements' + (amount ? ` | ${amount} €` : '');

  return (
    <CustomAccordion title={title}>
      <Grid container>
        <BusinessCommissionItem
          label="Courtier"
          enseigneName="CONNECTCRÉDIT"
          role={[Role.MANDATARY]}
          type="mandaCommissions"
          commissions={businessState.mandaCommissions}
          setBusinessState={setBusinessState}
          editable={canEditBusiness}
          apaId={businessState?.apa?.id}
        />
        <BusinessCommissionItem
          label="Apporteur"
          enseigneName={businessState?.apa?.enseigneName}
          type="apaCommissions"
          role={APAS}
          commissions={businessState.apaCommissions}
          setBusinessState={setBusinessState}
          editable={canEditBusiness}
          apaId={businessState?.apa?.id}
        />
      </Grid>
    </CustomAccordion>
  );
};

export default BusinessCommissions;
